import { IconShieldSuperAdmin } from '@shares/DMPIcon';
import { Col, Divider, Icon, Layout, Menu, notification, Row, Tabs } from 'antd';
import _, { isString } from 'lodash';
import queryString from 'query-string';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { BIGDATA_CONSTANT } from '../../common/constant';
import { getCurrentURL } from '../../common/helper';
import DashboardPageLayoutV2 from '../../layout/dashboard/DashboardPageLayoutV2';
import CronjobComponent from './cronjob/CronjobComponent';
import { FormImportSystemSystemSetting } from './FormImportSystemSetting';
import { FormAddPangoTemplate } from './manage_object/FormAddPangoTemplate';
import SystemConfigurationComponent from './system-configuration/SystemConfigurationComponent';
import { SystemDAL } from './SystemDAL';
import { IPropsSystemSettingComponent } from './SystemSettingContainer';
import ZMALiveVersionComponent from './zma-live-version/ZMALiveVersionComponent';
import { FormImportListZMAJson } from './zma/FormImportListZMAJson';
import PrivacySystem from './privacy-sytem';
import { Form } from '@extend/antd/form';
import PrivacySystemLogs from './privacy-logs';
import ButtonReloadCache from './components/ButtonReloadCache';

type TTabsSystemSetting = 'system' | 'zalo-mini-app' | 'cronjob';
type TMenuSystemSetting =
  | 'support'
  | 'segment'
  | 'manage_object'
  | 'system_configuration'
  | 'zma-live-version'
  | 'zma-library'
  | 'privacy-system'
  | 'privacy-logs';

type TSubMenuSystemSetting = 'security' | '';

export const SystemSettingComponentV2 = (props: IPropsSystemSettingComponent) => {
  // const [selectedMenu, setSelectedMenu] = React.useState<TMenuSystemSetting>('support');
  const [selectedTab, setSelectedTab] = React.useState<TTabsSystemSetting>('system');
  const [selectedMenu, setSelectedMenu] = React.useState<TMenuSystemSetting>('support');
  const [selectedSubMenu, setSelectedSubMenu] = React.useState<TSubMenuSystemSetting>('');

  React.useEffect(() => {
    const parsed = queryString.parse(props.location.search);
    if (_.isString(parsed['tab'])) {
      setSelectedTab(parsed['tab'] as TTabsSystemSetting);
    } else {
      setSelectedTab('system');
    }
    if (parsed.menu && isString(parsed.menu)) {
      setSelectedMenu(parsed.menu as TMenuSystemSetting);
    } else {
      if (parsed['tab'] === 'zalo-mini-app') {
        setSelectedMenu('zma-live-version');
      } else {
        setSelectedMenu('support');
      }
    }
    if (parsed.subMenu && isString(parsed.subMenu)) {
      setSelectedSubMenu(parsed.subMenu as TSubMenuSystemSetting);
    } else {
      setSelectedSubMenu('');
    }
  }, [props.location]);

  React.useEffect(() => {
    let timer = setTimeout(() => {
      props.updateMeta({
        name: BIGDATA_CONSTANT.trackTitle.ConsoleSystem,
        title: BIGDATA_CONSTANT.trackTitle.ConsoleSystem,
        app: 'ACCOUNT',
        url: getCurrentURL(props.location),
      });
      clearTimeout(timer);
    }, 5000);

    return () => {
      clearTimeout(timer);
    };
  }, [props.location]);

  // const renderBreadCrumb = () => {
  //   const getBreadCumItem = () => {
  //     switch (selectedMenu) {
  //       case "system":
  //         return "System"
  //       case "zalo-mini-app":
  //         return "Zalo Mini App"
  //       default:
  //         return null
  //     }
  //   }

  //   return (
  //     <Row type="flex" justify="space-between" align="middle" >
  //       <Breadcrumb>
  //         <Breadcrumb.Item>
  //           <Link to="/">Home</Link>
  //         </Breadcrumb.Item>

  //         <Breadcrumb.Item>System setting</Breadcrumb.Item>
  //         {
  //           selectedMenu && <Breadcrumb.Item>{getBreadCumItem()}</Breadcrumb.Item>
  //         }
  //       </Breadcrumb>

  //     </Row>

  //   )
  // }

  const renderContentLayout = (version?: string) => {
    return (
      <>
        <Tabs
          onChange={(tab: TTabsSystemSetting) => {
            setSelectedTab(tab);
            props.history.replace({ pathname: `/console-system-setting`, search: `?tab=${tab}` });
          }}
          defaultActiveKey={selectedTab}
          activeKey={selectedTab}
          destroyInactiveTabPane
          animated={false}
          hideAdd
        >
          <Tabs.TabPane tab={'System'} key='system'>
            <Layout>
              <Layout.Sider
                width={200}
                className={version === 'v2' ? 'main-menu-v3 menu-connection' : ''}
                style={{ background: '#fff', minHeight: '400px', marginRight: 12 }}
              >
                <Menu
                  style={{ background: '#fff', minHeight: '400px', height: 'inherit' }}
                  theme='light'
                  selectedKeys={[selectedMenu]}
                  openKeys={[selectedSubMenu]}
                  mode='inline'
                >
                  <Menu.Item key={'support'}>
                    <Link
                      to={{
                        pathname: 'console-system-setting',
                        search: 'tab=system&menu=support',
                      }}
                    >
                      Support Connection
                    </Link>
                  </Menu.Item>
                  <Menu.Item key={'segment'}>
                    <Link
                      to={{
                        pathname: 'console-system-setting',
                        search: 'tab=system&menu=segment',
                      }}
                    >
                      Segment Setting
                    </Link>
                  </Menu.Item>
                  <Menu.Item key={'manage_object'}>
                    <Link
                      to={{
                        pathname: 'console-system-setting',
                        search: 'tab=system&menu=manage_object',
                      }}
                    >
                      Managed Objects
                    </Link>
                  </Menu.Item>
                  <Menu.Item key={'system_configuration'}>
                    <Link
                      to={{
                        pathname: 'console-system-setting',
                        search: 'tab=system&menu=system_configuration',
                      }}
                    >
                      System Configuration
                    </Link>
                  </Menu.Item>

                  <Menu.SubMenu
                    key='security'
                    title='Security'
                    onTitleClick={(e) => {
                      if (e.key !== selectedSubMenu) {
                        setSelectedSubMenu(e.key as TSubMenuSystemSetting);
                      } else {
                        setSelectedSubMenu('');
                      }
                    }}
                  >
                    <Menu.Item key={'privacy-system'}>
                      <Link
                        to={{
                          pathname: 'console-system-setting',
                          search: 'tab=system&subMenu=security&menu=privacy-system',
                        }}
                      >
                        Privacy System
                      </Link>
                    </Menu.Item>
                    <Menu.Item key={'privacy-logs'}>
                      <Link
                        to={{
                          pathname: 'console-system-setting',
                          search: 'tab=system&subMenu=security&menu=privacy-logs',
                        }}
                      >
                        Logs
                      </Link>
                    </Menu.Item>
                  </Menu.SubMenu>
                </Menu>
              </Layout.Sider>

              <Layout.Content style={{ overflow: 'hidden' }}>
                {selectedMenu == 'support' ? (
                  <Row gutter={[5, 10]}>
                    <Col xs={24}>
                      <FormImportSystemSystemSetting
                        label=''
                        title={'Import Support Connection'}
                        onSubmit={(values: any, callback: any) => {
                          props
                            .commonActionFromDAL(SystemDAL, 'importSupportedConnection', values.file.file)
                            .then((e: any) => {
                              callback();
                              if (e.success) {
                                notification.success({
                                  message: 'Success',
                                  description: _.get(e, 'message', 'Import support connection successfully.'),
                                });
                              } else {
                                notification.error({
                                  message: 'Error',
                                  description: _.get(e, 'message', 'Something was wrong.'),
                                });
                              }
                            })
                            .catch(() => {
                              callback();
                            });
                        }}
                      />
                    </Col>
                    <Col xs={24}>
                      <FormImportSystemSystemSetting
                        label='Enter Id'
                        title='Delete Support Connection'
                        isDeleteSupportConnection={true}
                        labelButton='Delete'
                        onSubmit={(values: any, callback: any) => {
                          props
                            .commonActionFromDAL(SystemDAL, 'deleteSupportConnection', values.id)
                            .then((e: any) => {
                              callback();
                              if (e.success) {
                                notification.success({
                                  message: 'Success',
                                  description: _.get(e, 'message', 'Delete successfully.'),
                                });
                              } else {
                                notification.error({
                                  message: 'Error',
                                  description: _.get(e, 'message', 'Something was wrong.'),
                                });
                              }
                            })
                            .catch(() => {
                              callback();
                            });
                        }}
                      />
                    </Col>
                  </Row>
                ) : null}

                {selectedMenu == 'segment' ? (
                  <Row gutter={[5, 10]}>
                    <Col xs={24}>
                      <FormImportSystemSystemSetting
                        label=''
                        title='Import Segment Meta'
                        onSubmit={(values: any, callback: any) => {
                          props
                            .commonActionFromDAL(SystemDAL, 'importSegmentMeta', values.file.file)
                            .then((e: any) => {
                              callback();
                              if (e.success) {
                                notification.success({
                                  message: 'Success',
                                  description: _.get(e, 'message', 'Import successfully.'),
                                });
                              } else {
                                notification.error({
                                  message: 'Error',
                                  description: _.get(e, 'message', 'Something was wrong.'),
                                });
                              }
                            })
                            .catch(() => {
                              callback();
                            });
                        }}
                      />
                    </Col>
                    <Col xs={24}>
                      <FormImportSystemSystemSetting
                        label='Enter Meta Id'
                        title='Delete Segment Meta'
                        isDeleteSupportConnection={true}
                        labelButton='Delete'
                        onSubmit={(values: any, callback: any) => {
                          props
                            .commonActionFromDAL(SystemDAL, 'deleteSegmentMeta', values.id)
                            .then((e: any) => {
                              callback();
                              if (e.success) {
                                notification.success({
                                  message: 'Success',
                                  description: _.get(e, 'message', 'Delete successfully.'),
                                });
                              } else {
                                notification.error({
                                  message: 'Error',
                                  description: _.get(e, 'message', 'Something was wrong.'),
                                });
                              }
                            })
                            .catch(() => {
                              callback();
                            });
                        }}
                      />
                    </Col>
                  </Row>
                ) : null}

                {selectedMenu == 'manage_object' ? (
                  <Row gutter={[5, 10]}>
                    <Col xs={24}>
                      <FormImportSystemSystemSetting
                        label=''
                        isMoM={true}
                        title={
                          <React.Fragment>
                            MOM Import <Divider type='vertical' />{' '}
                            <a
                              target='_blank'
                              href='https://docs.google.com/spreadsheets/d/1lo-tJm7UxocRNFra29IrFlOFNY20GJitNjkg2avsw8c/edit#gid=0'
                            >
                              Link
                            </a>
                          </React.Fragment>
                        }
                        onSubmit={(values: any, callback: any) => {
                          props
                            .commonActionFromDAL(SystemDAL, 'importMOM', values.file.file)
                            .then((e: any) => {
                              callback();
                              if (e.success) {
                                notification.success({
                                  message: 'Success',
                                  description: _.get(e, 'message', 'Import successfully.'),
                                });
                              } else {
                                notification.error({
                                  message: 'Error',
                                  description: _.get(e, 'message', 'Something was wrong.'),
                                });
                              }
                            })
                            .catch(() => {
                              callback();
                            });
                        }}
                      />
                    </Col>
                    <Col xs={24}>
                      <FormImportSystemSystemSetting
                        isMoMField={true}
                        label=''
                        title={
                          <React.Fragment>
                            MOM Field Import <Divider type='vertical' />{' '}
                            <a
                              target='_blank'
                              href='https://docs.google.com/spreadsheets/d/1_CQOu9oMAohRO8t27myneztEJCTzLQjTUD5WuvK62H4/edit#gid=1480763222'
                            >
                              Link 1
                            </a>
                            <Divider type='vertical' />{' '}
                            <a
                              target='_blank'
                              href='https://docs.google.com/spreadsheets/d/1_9KS9ZniFwNeIyw18ainUj_0nxlrIxtU7QgQSbx_OCk/edit#gid=1139351055'
                            >
                              Link 2
                            </a>
                            <Divider type='vertical' /> <ButtonReloadCache />
                          </React.Fragment>
                        }
                        onSubmit={(values: any, callback: any) => {
                          props
                            .commonActionFromDAL(SystemDAL, 'importMOMField', values.file.file, values.objectModel)
                            .then((e: any) => {
                              callback();
                              if (e.success) {
                                notification.success({
                                  message: 'Success',
                                  description: _.get(e, 'message', 'Import successfully.'),
                                });
                              } else {
                                notification.error({
                                  message: 'Error',
                                  description: _.get(e, 'message', 'Something was wrong.'),
                                });
                              }
                            })
                            .catch(() => {
                              callback();
                            });
                        }}
                      />
                    </Col>
                    <Col xs={24}>
                      <FormAddPangoTemplate commonActionFromDALV2={props.commonActionFromDALV2} />
                    </Col>
                    <Col xs={24}>
                      <FormImportSystemSystemSetting
                        label='Enter Id'
                        title='Delete Pango Template'
                        isDeleteSupportConnection={true}
                        labelButton='Delete'
                        onSubmit={(values: any, callback: any) => {
                          props
                            .commonActionFromDAL(SystemDAL, 'deletePangoTemplate', values.id)
                            .then((e: any) => {
                              callback();
                              if (e.success) {
                                notification.success({
                                  message: 'Success',
                                  description: _.get(e, 'message', 'Delete successfully.'),
                                });
                              } else {
                                notification.error({
                                  message: 'Error',
                                  description: _.get(e, 'message', 'Something was wrong.'),
                                });
                              }
                            })
                            .catch(() => {
                              callback();
                            });
                        }}
                      />
                    </Col>
                  </Row>
                ) : null}

                {selectedMenu === 'system_configuration' ? <SystemConfigurationComponent {...props} /> : null}

                {selectedMenu === 'privacy-system' ? (
                  <Form.Provider>
                    <PrivacySystem />
                  </Form.Provider>
                ) : null}

                {selectedMenu === 'privacy-logs' ? <PrivacySystemLogs /> : null}
              </Layout.Content>
            </Layout>
          </Tabs.TabPane>

          <Tabs.TabPane tab={'Zalo Mini App'} key='zalo-mini-app'>
            <Layout>
              <Layout.Sider
                width={200}
                className={version === 'v2' ? 'main-menu-v3 menu-connection' : ''}
                style={{ background: '#fff', minHeight: '400px', marginRight: 12 }}
              >
                <Menu
                  style={{ background: '#fff', minHeight: '400px', height: 'inherit' }}
                  theme='light'
                  mode='inline'
                  selectedKeys={[selectedMenu]}
                >
                  <Menu.Item key={'zma-live-version'}>
                    <Link
                      to={{
                        pathname: 'console-system-setting',
                        search: 'tab=zalo-mini-app&menu=zma-live-version',
                      }}
                    >
                      ZMA Live Version
                    </Link>
                  </Menu.Item>
                  <Menu.Item key={'zma-library'}>
                    <Link
                      to={{
                        pathname: 'console-system-setting',
                        search: 'tab=zalo-mini-app&menu=zma-library',
                      }}
                    >
                      ZMA Library
                    </Link>
                  </Menu.Item>
                </Menu>
              </Layout.Sider>

              <Layout.Content style={{ overflow: 'hidden' }}>
                {selectedMenu === 'zma-library' && (
                  <>
                    <Row gutter={[10, 10]}>
                      <Col xs={24}>
                        <FormImportListZMAJson commonActionFromDALV2={props.commonActionFromDALV2} />
                      </Col>
                      <Col xs={24}>
                        <FormImportSystemSystemSetting
                          label='Enter Id'
                          title='Delete Support Connection'
                          isDeleteSupportConnection={true}
                          labelButton='Delete'
                          onSubmit={(values: any, callback: any) => {
                            props
                              .commonActionFromDAL(SystemDAL, 'deleteSupportConnectionZMA', values.id)
                              .then((e: any) => {
                                callback();
                                if (e.success) {
                                  notification.success({
                                    message: 'Success',
                                    description: _.get(e, 'message', 'Delete successfully.'),
                                  });
                                } else {
                                  notification.error({
                                    message: 'Error',
                                    description: _.get(e, 'message', 'Something was wrong.'),
                                  });
                                }
                              })
                              .catch(() => {
                                callback();
                              });
                          }}
                        />
                      </Col>
                    </Row>
                  </>
                )}

                {selectedMenu === 'zma-live-version' && <ZMALiveVersionComponent {...props} />}
              </Layout.Content>
            </Layout>
          </Tabs.TabPane>

          <Tabs.TabPane tab={'Cronjob'} key='cronjob'>
            <CronjobComponent version={version} {...props} />
          </Tabs.TabPane>
        </Tabs>

        {/* <Menu
       style={{ background: '#fff', minHeight: '400px', height: 'inherit' }}
       theme="light"
       selectedKeys={[selectedMenu]}
     >
       <Menu.Item key={'system'}>
         <Link
           to={{
             pathname: 'console-system-setting',
             search: 'tab=system',
           }}
         >
           System
         </Link>
       </Menu.Item>
       <Menu.Item key={'zalo-mini-app'}>
         <Link
           to={{
             pathname: 'console-system-setting',
             search: 'tab=zalo-mini-app',
           }}
         >
           Zalo Mini App
         </Link>
       </Menu.Item>
       <Menu.Item key={'cronjob'}>
         <Link
           to={{
             pathname: 'console-system-setting',
             search: 'tab=cronjob',
           }}
         >
           Cronjob
         </Link>
       </Menu.Item>
     </Menu> */}
        {/* <Layout.Content style={{ paddingLeft: 10, overflow: 'hidden' }}>
          {selectedMenu === 'system' && (
            <Layout>
              <Layout.Sider width={200} style={{ background: '#fff', minHeight: '400px', marginRight: 12 }}>
                <Menu
                  style={{ background: '#fff', minHeight: '400px', height: 'inherit' }}
                  theme="light"
                  selectedKeys={[selectedMenu]}
                >
                  <Menu.Item key={'support'}>
                    <Link
                      to={{
                        pathname: 'console-system-setting',
                        search: 'tab=system&menu=support',
                      }}
                    >
                      Support Connection
                    </Link>
                  </Menu.Item>
                  <Menu.Item key={'segment'}>
                    <Link
                      to={{
                        pathname: 'console-system-setting',
                        search: 'tab=system&menu=segment',
                      }}
                    >
                      Segment Setting
                    </Link>
                  </Menu.Item>
                  <Menu.Item key={'manage_object'}>
                    <Link
                      to={{
                        pathname: 'console-system-setting',
                        search: 'tab=system&menu=manage_object',
                      }}
                    >
                      Managed Objects
                    </Link>
                  </Menu.Item>
                  <Menu.Item key={'system_configuration'}>
                    <Link
                      to={{
                        pathname: 'console-system-setting',
                        search: 'tab=system&menu=system_configuration',
                      }}
                    >
                      System Configuration
                    </Link>
                  </Menu.Item>
                </Menu>
              </Layout.Sider>

              <Layout.Content style={{ overflow: 'hidden' }}>
                {selectedMenu == 'support' ? (
                  <Row gutter={[5, 10]}>
                    <Col xs={24}>
                      <FormImportSystemSystemSetting
                        label=""
                        title={'Import Support Connection'}
                        onSubmit={(values: any, callback: any) => {
                          props
                            .commonActionFromDAL(SystemDAL, 'importSupportedConnection', values.file.file)
                            .then((e: any) => {
                              callback();
                              if (e.success) {
                                notification.success({
                                  message: 'Success',
                                  description: _.get(e, 'message', 'Import support connection successfully.'),
                                });
                              } else {
                                notification.error({
                                  message: 'Error',
                                  description: _.get(e, 'message', 'Something was wrong.'),
                                });
                              }
                            })
                            .catch(() => {
                              callback();
                            });
                        }}
                      />
                    </Col>
                    <Col xs={24}>
                      <FormImportSystemSystemSetting
                        label="Enter Id"
                        title="Delete Support Connection"
                        isDeleteSupportConnection={true}
                        labelButton="Delete"
                        onSubmit={(values: any, callback: any) => {
                          props
                            .commonActionFromDAL(SystemDAL, 'deleteSupportConnection', values.id)
                            .then((e: any) => {
                              callback();
                              if (e.success) {
                                notification.success({
                                  message: 'Success',
                                  description: _.get(e, 'message', 'Delete successfully.'),
                                });
                              } else {
                                notification.error({
                                  message: 'Error',
                                  description: _.get(e, 'message', 'Something was wrong.'),
                                });
                              }
                            })
                            .catch(() => {
                              callback();
                            });
                        }}
                      />
                    </Col>
                  </Row>
                ) : null}

                {selectedMenu == 'segment' ? (
                  <Row gutter={[5, 10]}>
                    <Col xs={24}>
                      <FormImportSystemSystemSetting
                        label=""
                        title="Import Segment Meta"
                        onSubmit={(values: any, callback: any) => {
                          props
                            .commonActionFromDAL(SystemDAL, 'importSegmentMeta', values.file.file)
                            .then((e: any) => {
                              callback();
                              if (e.success) {
                                notification.success({
                                  message: 'Success',
                                  description: _.get(e, 'message', 'Import successfully.'),
                                });
                              } else {
                                notification.error({
                                  message: 'Error',
                                  description: _.get(e, 'message', 'Something was wrong.'),
                                });
                              }
                            })
                            .catch(() => {
                              callback();
                            });
                        }}
                      />
                    </Col>
                    <Col xs={24}>
                      <FormImportSystemSystemSetting
                        label="Enter Meta Id"
                        title="Delete Segment Meta"
                        isDeleteSupportConnection={true}
                        labelButton="Delete"
                        onSubmit={(values: any, callback: any) => {
                          props
                            .commonActionFromDAL(SystemDAL, 'deleteSegmentMeta', values.id)
                            .then((e: any) => {
                              callback();
                              if (e.success) {
                                notification.success({
                                  message: 'Success',
                                  description: _.get(e, 'message', 'Delete successfully.'),
                                });
                              } else {
                                notification.error({
                                  message: 'Error',
                                  description: _.get(e, 'message', 'Something was wrong.'),
                                });
                              }
                            })
                            .catch(() => {
                              callback();
                            });
                        }}
                      />
                    </Col>
                  </Row>
                ) : null}

                {selectedMenu == 'manage_object' ? (
                  <Row gutter={[5, 10]}>
                    <Col xs={24}>
                      <FormImportSystemSystemSetting
                        label=""
                        isMoM={true}
                        title={
                          <React.Fragment>
                            MOM Import <Divider type="vertical" />{' '}
                            <a
                              target="_blank"
                              href="https://docs.google.com/spreadsheets/d/1lo-tJm7UxocRNFra29IrFlOFNY20GJitNjkg2avsw8c/edit#gid=0"
                            >
                              Link
                            </a>
                          </React.Fragment>
                        }
                        onSubmit={(values: any, callback: any) => {
                          props
                            .commonActionFromDAL(SystemDAL, 'importMOM', values.file.file)
                            .then((e: any) => {
                              callback();
                              if (e.success) {
                                notification.success({
                                  message: 'Success',
                                  description: _.get(e, 'message', 'Import successfully.'),
                                });
                              } else {
                                notification.error({
                                  message: 'Error',
                                  description: _.get(e, 'message', 'Something was wrong.'),
                                });
                              }
                            })
                            .catch(() => {
                              callback();
                            });
                        }}
                      />
                    </Col>
                    <Col xs={24}>
                      <FormImportSystemSystemSetting
                        isMoMField={true}
                        label=""
                        title={
                          <React.Fragment>
                            MOM Field Import <Divider type="vertical" />{' '}
                            <a
                              target="_blank"
                              href="https://docs.google.com/spreadsheets/d/1_CQOu9oMAohRO8t27myneztEJCTzLQjTUD5WuvK62H4/edit#gid=1480763222"
                            >
                              Link 1
                            </a>
                            <Divider type="vertical" />{' '}
                            <a
                              target="_blank"
                              href="https://docs.google.com/spreadsheets/d/1_9KS9ZniFwNeIyw18ainUj_0nxlrIxtU7QgQSbx_OCk/edit#gid=1139351055"
                            >
                              Link 2
                            </a>
                          </React.Fragment>
                        }
                        onSubmit={(values: any, callback: any) => {
                          props
                            .commonActionFromDAL(SystemDAL, 'importMOMField', values.file.file, values.objectModel)
                            .then((e: any) => {
                              callback();
                              if (e.success) {
                                notification.success({
                                  message: 'Success',
                                  description: _.get(e, 'message', 'Import successfully.'),
                                });
                              } else {
                                notification.error({
                                  message: 'Error',
                                  description: _.get(e, 'message', 'Something was wrong.'),
                                });
                              }
                            })
                            .catch(() => {
                              callback();
                            });
                        }}
                      />
                    </Col>
                    <Col xs={24}>
                      <FormAddPangoTemplate commonActionFromDALV2={props.commonActionFromDALV2} />
                    </Col>
                    <Col xs={24}>
                      <FormImportSystemSystemSetting
                        label="Enter Id"
                        title="Delete Pango Template"
                        isDeleteSupportConnection={true}
                        labelButton="Delete"
                        onSubmit={(values: any, callback: any) => {
                          props
                            .commonActionFromDAL(SystemDAL, 'deletePangoTemplate', values.id)
                            .then((e: any) => {
                              callback();
                              if (e.success) {
                                notification.success({
                                  message: 'Success',
                                  description: _.get(e, 'message', 'Delete successfully.'),
                                });
                              } else {
                                notification.error({
                                  message: 'Error',
                                  description: _.get(e, 'message', 'Something was wrong.'),
                                });
                              }
                            })
                            .catch(() => {
                              callback();
                            });
                        }}
                      />
                    </Col>
                  </Row>
                ) : null}
                {selectedMenu === 'system_configuration' ? <SystemConfigurationComponent {...props} /> : null}
              </Layout.Content>
            </Layout>
          )}

          {selectedMenu === 'zalo-mini-app' && (
            <Layout>
              <Layout.Sider width={200} style={{ background: '#fff', minHeight: '400px', marginRight: 12 }}>
                <Menu
                  style={{ background: '#fff', minHeight: '400px', height: 'inherit' }}
                  theme="light"
                  selectedKeys={[selectedMenu]}
                >
                  <Menu.Item key={'zma-live-version'}>
                    <Link
                      to={{
                        pathname: 'console-system-setting',
                        search: 'tab=zalo-mini-app&menu=zma-live-version',
                      }}
                    >
                      ZMA Live Version
                    </Link>
                  </Menu.Item>
                  <Menu.Item key={'zma-library'}>
                    <Link
                      to={{
                        pathname: 'console-system-setting',
                        search: 'tab=zalo-mini-app&menu=zma-library',
                      }}
                    >
                      ZMA Library
                    </Link>
                  </Menu.Item>
                </Menu>
              </Layout.Sider>

              <Layout.Content style={{ overflow: 'hidden' }}>
                {selectedMenu === 'zma-library' && (
                  <>
                    <Row gutter={[5, 10]}>
                      <Col xs={24}>
                        <FormImportListZMAJson commonActionFromDALV2={props.commonActionFromDALV2} />
                      </Col>
                      <Col xs={24}>
                        <FormImportSystemSystemSetting
                          label="Enter Id"
                          title="Delete Support Connection"
                          isDeleteSupportConnection={true}
                          labelButton="Delete"
                          onSubmit={(values: any, callback: any) => {
                            props
                              .commonActionFromDAL(SystemDAL, 'deleteSupportConnectionZMA', values.id)
                              .then((e: any) => {
                                callback();
                                if (e.success) {
                                  notification.success({
                                    message: 'Success',
                                    description: _.get(e, 'message', 'Delete successfully.'),
                                  });
                                } else {
                                  notification.error({
                                    message: 'Error',
                                    description: _.get(e, 'message', 'Something was wrong.'),
                                  });
                                }
                              })
                              .catch(() => {
                                callback();
                              });
                          }}
                        />
                      </Col>
                    </Row>
                  </>
                )}

                {selectedMenu === 'zma-live-version' && <ZMALiveVersionComponent {...props} />}
              </Layout.Content>
            </Layout>
          )}

          {selectedMenu === 'cronjob' && <CronjobComponent {...props} />}
        </Layout.Content> */}
      </>
    );
  };

  const render = () => {
    return (
      <DashboardPageLayoutV2
        props={props}
        selectedLeftNavStandard='menu_import'
        selectedSubMenuStandard='console-super'
        breadcrumbItemsStandard={[
          {
            title: 'Home',
            path: '/',
          },
          {
            title: 'Super Admin',
          },
          {
            title: 'Settings',
          },
        ]}
        breadcrumbItemsModern={[
          {
            title: 'Account',
            path: '/',
          },
          {
            title: 'Super Admin',
          },
          {
            title: 'Settings',
          },
        ]}
        pageTitle='Settings'
        pageTitleIcon={<Icon component={IconShieldSuperAdmin} />}
        renderContentLayout={renderContentLayout}
        metaTitle={props.ui.meta.title}
      />
    );
  };

  return render();
};
